import React from 'react'
import Navbar from '../Navbar'
import '../css/article-insights.css'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from 'react-router-dom';
export const ArticlePage = () => {
  return (
    <>
    <Navbar/>
    

<div className="wrapper" id='article-insights'>
 
  <div className="article-grid">
    <div className="article-item">
      <div className="image-box">
        <Link to="/article1">
        <img src="./images/UFC.jpg" />
        </Link>
      </div>
      <Link to="/article1" className='article-showcase'>
      <h2 id='dd'>
      UFC’s Financial Power Play: Growth, Earnings, and Future Prospects
      </h2>
      <p>
      The Ultimate Fighting Championship (UFC), under the dynamic leadership of Dana White, continues to dominate the global combat sports...
      </p>
      </Link>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <Link href="#">Read More »</Link>
    </div>
    <div className="article-item">
      <div className="image-box">
        <Link to="/article2">
        <img src="./images/google.jpg" alt="News Image 2" />
        </Link>
      </div>
      <Link to="/article2" className='article-showcase'>
      <h2>Google Defends Practices in High-Stakes Antitrust Case</h2>
      <p>
      It claims the digital advertising space includes other big players like social media and streaming platforms...
      </p>
      </Link>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <Link href="#">Read More »</Link>
    </div>
    <div className="article-item">
      <div className="image-box">
        <Link to="/article3">
        <img src="./images/foxcon.jpg" alt="News Image 3" />
        </Link>
      </div>
      <Link to="/article3" className='article-showcase'>
      <h2>Foxconn’s $80 Million Investment in Vietnam for Circuit Production</h2>
      <p>Taiwanese tech giant Foxconn announced an $80 million investment in Vietnam to enhance its production of integrated circuits...</p>
      </Link>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <Link href="#">Read More »</Link>
    </div>
    <div className="article-item">
      <div className="image-box">
        <Link to="/article4">
        <img src="./images/kroger-albertsons-merger.jpg" alt="News Image 4" />
        </Link>
      </div>
      <Link to="/article4" className='article-showcase'>
      <h2>
      Kroger-Albertsons Merger: A Game-Changer for the U.S. Grocery Industry
      </h2>
      <p>
      In a groundbreaking move set to redefine the grocery landscape, Kroger and Albertsons have announced their plans to merge in a deal...
      </p>
      </Link>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <Link href="#">Read More »</Link>
    </div>
    <div className="article-item">
      <div className="image-box">
        <Link to="/article5">
        <img src="./images/toxic-communication.jpg" alt="News Image 5" />
        </Link>
      </div>
      <Link to="/article5" className='article-showcase'>
      <h2>How to Break 8 Toxic Communication Habits</h2>
      <p>If you want to excel at pickleball, cake-decorating, or playing the piano, you’ll probably sign up for a class or enlist an instructor...</p>
      </Link>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <Link href="#">Read More »</Link>
    </div>
    <div className="article-item">
      <div className="image-box">
        <Link to="/article6">
        <img src="./images/vodacom.jpg" alt="News Image 6" />
        </Link>
      </div>
      <Link to="/article6" className='article-showcase'>
      <h2>
      Blocked Vodacom Merger Hinders South African Telco Market
      </h2>
      <p>
      A significant merger between telecom giants Vodacom and MTN was blocked by South African regulators...
      </p>
      </Link>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <Link href="#">Read More »</Link>
    </div>
    <div className="article-item">
      <div className="image-box">
        <Link to="/article7">
        <img src="./images/Am-football.jpg" alt="News Image 7" />
        </Link>
      </div>
      <Link to="/article7" className='article-showcase'>
      <h2>
      Top 10 Football Players of 2024: Dominating the NFL Season
      </h2>
      <p>As the 2024 NFL season progresses, fans and analysts alike are keeping a close eye on the league’s top performers...</p>
      </Link>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <Link href="#">Read More »</Link>
    </div>
    <div className="article-item">
      <div className="image-box">
        <Link to="/article8" >
        <img src="./images/japan-rocket.jpg" alt="News Image 8" />
        </Link>
      </div>
      <Link to="/article8" className='article-showcase'>
      <h2>
      Japan Launches Military Communications Satellite
      </h2>
      <p>Japan successfully launched its Kirameki No. 3 satellite, designed to enhance secure communications for military operations.</p>
      </Link>
      <p className="text-muted">By Steve  | TSD Staff</p>
      <Link href="#"> Read More »</Link>
    </div>
   
  </div>
</div>
</>
  )
}
